import script from "./EvalRunDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./EvalRunDetail.vue?vue&type=script&setup=true&lang=js"

import "./EvalRunDetail.vue?vue&type=style&index=0&id=70384308&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70384308"]])

export default __exports__